const ServiceListData = {
  'papakilo-man': {
    'hair-treatments-man': [
      {
        title: "Papakilo Haircut",
        price: "100K",
        description: "Cold Towel, Cut Hair, Message, Wash, Hot Towel, Hairtonic, dan Styling"
      },
      {
        title: "Papakilo Haircut + Hair Tattoo",
        price: "150K",
        description: "Cold Towel, Cut Hair, Hair Tattoo, Message, Wash, Hot Towel, Hairtonic, dan Styling"
      },
      {
        title: "Papakilo Haircut Pro",
        price: "229K",
        description: "Cold Towel, First Wash, Cut Hair, Message, Second Wash, Creambath, Komedo Removel, Hairtonic, dan Styling"
      },
      {
        title: "Papakilo Premium Cut",
        price: "250K",
        description: "Cold Towel, First Wash, Cut Hair, Message, Second Wash, Creambath, Premium Face Mask, Nano Hairspa, Hairtonic, dan Styling"
      }
    ],

    'coloring': [
      {
        title: "Papakilo Jetstream Color",
        price: "250K",
        description: "Pewarnaan rambut dasar dengan bleaching, mencakup konsultasi warna, pewarnaan, hair tonic, dan styling untuk hasil yang maksimal"
      },
      {
        title: "Fashion Color (1 Color)",
        price: "550K",
        description: "Single color fashionable dengan proses bleaching premium, termasuk konsultasi warna, pewarnaan fashion, hair mask, dan styling profesional"
      },
      {
        title: "Fashion Color (2 Color)",
        price: "650K",
        description: "Kombinasi 2 warna fashion dengan bleaching premium, termasuk konsultasi warna, pewarnaan fashion ganda, hair mask, dan styling kreatif"
      },
      {
        title: "Fashion Color (3 Color)",
        price: "750K",
        description: "Kombinasi 3 warna fashion dengan bleaching premium, mencakup konsultasi warna, pewarnaan fashion triple, hair mask, dan styling artistik"
      }
    ],

    'massage-treatments': [
      {
        title: "Papakilo Beard Trim",
        price: "35K",
        description: "Pijat kepala dan kulit kepala untuk relaksasi"
      },
      {
        title: "Papakilo Wash Hair + Dryer",
        price: "50K",
        description: "Pijat kepala premium dengan minyak esensial"
      },
      {
        title: "Papakilo Creambath Basic + Dryer",
        price: "100K",
        description: "Potong rambut dasar untuk anak-anak"
      },
      {
        title: "Papakilo Creambath + Nano Spa",
        price: "150K",
        description: "Potong rambut dengan style untuk anak-anak"
      }
    ],

    'kids': [
      {
        title: "Papakilo Grooming for Kids (under 12 years old)",
        price: "100K",
        description: "Layanan potong rambut khusus anak-anak dibawah 12 tahun, termasuk konsultasi gaya rambut, pijatan ringan, dan styling yang sesuai dengan karakter anak"
      },
      {
        title: "Wash Hair + Dryer for Kids",
        price: "55K",
        description: "Layanan cuci rambut dan blow dry khusus anak-anak dengan produk lembut dan aman, termasuk pijatan ringan untuk kenyamanan"
      },
      {
        title: "Styling Hair for Kids",
        price: "35K",
        description: "Layanan styling rambut anak dengan produk khusus anak-anak, membuat penampilan lebih rapi dan fresh untuk aktivitas"
      }
    ],
    'smoothing-perm': [
      {
        title: "Smoothing",
        price: "Starting from: 300K",
        description: "Pelurusan rambut dengan teknologi smoothing terkini, memberikan hasil rambut lurus natural dan mudah diatur, disesuaikan dengan jenis dan kondisi rambut"
      },
      {
        title: "Smoothing Keratin",
        price: "Starting from: 700K",
        description: "Treatment premium dengan teknologi keratin, memberikan hasil rambut lurus, berkilau, dan bebas kusut hingga berbulan-bulan, plus perawatan intensif"
      },
      {
        title: "Keratin",
        price: "Starting from: 300K",
        description: "Perawatan khusus dengan keratin untuk memulihkan kerusakan rambut, memperkuat struktur rambut, dan memberikan kilau alami"
      },
      {
        title: "Perm / Downperm",
        price: "Starting from: 300K",
        description: "Teknik styling permanen untuk menciptakan tekstur bergelombang atau ikal sesuai keinginan, dengan hasil yang tahan lama dan terlihat natural"
      }
    ],

    'additional-treatments': [
      {
        title: "Fleas Removal (Pembasmi Kutu)",
        price: "200K",
        description: "Wash, Obat Kutu, Head Massage, Tonic, Nano Hair, Cold Towel, dan Hot Towel"
      },
      {
        title: "Serum Rambut",
        price: "35K",
        description: "Perawatan serum untuk melindungi dan memberikan kilau alami pada rambut"
      },
      {
        title: "Komedo Remover",
        price: "35K",
        description: "Treatment pembersihan komedo dengan teknik profesional untuk wajah lebih bersih"
      },
      {
        title: "Waxing",
        price: "35K",
        description: "Perawatan waxing untuk mengangkat bulu-bulu halus di wajah dengan aman dan nyaman"
      },
      {
        title: "Ear Candle Treatment",
        price: "50K",
        description: "Terapi telinga dengan ear candle untuk membersihkan dan menyegarkan area telinga"
      },
      {
        title: "Shield Mask Medium",
        price: "60K",
        description: "Masker wajah premium untuk melembabkan dan mencerahkan kulit wajah"
      },
      {
        title: "Shield Mask Gold",
        price: "80K",
        description: "Masker wajah premium dengan kandungan emas untuk merawat dan meremajakan kulit wajah"
      },
      {
        title: "Hair Spa Scrub",
        price: "175K",
        description: "Perawatan spa rambut lengkap dengan scrub untuk membersihkan kulit kepala secara mendalam"
      },
      {
        title: "Totok Wajah, Face Massage, Face Mask, dan Ear Candle Treatment",
        price: "230K",
        description: "Paket perawatan wajah lengkap termasuk totok wajah, pijat wajah, masker, dan ear candle untuk relaksasi maksimal"
      }
    ]
  },
    
  'papakilo-woman': {
    'cut-styling': [
      {
        title: "Cut + Wash + Dryer",
        price: "180K",
        description: "Paket lengkap potong rambut dengan pencucian menggunakan shampo premium, dan pengeringan profesional untuk hasil maksimal"
      },
      {
        title: "Cut + Wash + Blow Natural",
        price: "200K",
        description: "Kombinasi potong rambut, pencucian, dan blow natural untuk tampilan rambut yang lebih alami dan bervolume"
      },
      {
        title: "Cut + Wash + Blow Styling",
        price: "250K",
        description: "Paket premium termasuk potong rambut, pencucian, dan blow styling khusus sesuai keinginan untuk tampilan yang lebih stylish"
      },
      {
        title: "Cutting Bangs (Potong Poni)",
        price: "50K",
        description: "Layanan potong poni profesional, disesuaikan dengan bentuk wajah dan gaya yang diinginkan"
      },
      {
        title: "Cutting Bangs (Potong Poni) + Wash + Dry",
        price: "100K",
        description: "Paket potong poni lengkap dengan pencucian rambut dan pengeringan untuk hasil yang lebih maksimal"
      },
      {
        title: "Wash + Tonic + Serum + Dryer",
        price: "70K",
        description: "Perawatan rambut lengkap meliputi pencucian, aplikasi hair tonic dan serum, serta pengeringan profesional"
      },
      {
        title: "Wash + Blow Natural",
        price: "130K",
        description: "Kombinasi pencucian rambut dan blow natural untuk tampilan rambut sehat dan bervolume secara alami"
      },
      {
        title: "Wash + Blow Variation/Curly",
        price: "185K",
        description: "Layanan pencucian dan styling khusus untuk menciptakan variasi gaya atau tambahan volume dengan tekstur bergelombang"
      },
      {
        title: "Wash + Catok",
        price: "130K",
        description: "Paket pencucian rambut dilanjutkan dengan catok untuk hasil rambut yang lebih lurus dan rapi"
      },
      {
        title: "Catok Only",
        price: "100K",
        description: "Layanan catok rambut profesional untuk tampilan rambut yang lebih lurus dan berkilau"
      }
    ],

    'hair-treatments-woman': [
      {
        title: "Creambath + Dryer",
        price: "125K",
        description: "Perawatan rambut dengan creambath untuk nutrisi rambut, termasuk pijatan kepala, dan pengeringan rambut profesional"
      },
      {
        title: "Creambath + Blow/Catok",
        price: "157K",
        description: "Perawatan creambath lengkap dengan pilihan styling blow atau catok, memberikan hasil rambut lebih tertata dan berkilau"
      },
      {
        title: "Creambath + Blow Variation/Curly",
        price: "167K",
        description: "Kombinasi creambath dengan styling blow variasi atau curly untuk tampilan yang lebih dinamis dan bervolume"
      },
      {
        title: "Creambath + Nano Spa",
        price: "200K",
        description: "Treatment premium dengan creambath dan nano spa untuk perawatan mendalam, membuat rambut lebih sehat dan bernutrisi"
      },
      {
        title: "Hair Mask + Dryer",
        price: "200K",
        description: "Perawatan intensif dengan hair mask untuk rambut rusak, dilengkapi dengan pengeringan profesional"
      },
      {
        title: "Hair Mask + Blow/Catok",
        price: "230K",
        description: "Treatment hair mask untuk rambut rusak dengan tambahan styling blow atau catok untuk hasil lebih maksimal"
      },
      {
        title: "Hair Mask + Blow/Variation/Curly",
        price: "250K",
        description: "Kombinasi hair mask dengan styling blow variasi atau curly, cocok untuk rambut rusak yang ingin tampil lebih gaya"
      },
      {
        title: "Hair Spa + Dryer",
        price: "227K",
        description: "Spa rambut premium untuk perawatan mendalam, termasuk pijatan kepala dan pengeringan profesional"
      },
      {
        title: "Hair Spa + Blow/Catok",
        price: "250K",
        description: "Treatment hair spa lengkap dengan pilihan styling blow atau catok untuk hasil yang lebih tahan lama"
      },
      {
        title: "Hair Spa + Blow/Variation/Curly",
        price: "277K",
        description: "Paket lengkap hair spa dengan styling khusus untuk tampilan bervolume atau bergelombang yang tahan lama"
      }
    ],
    
    'coloring-perm': [
      {
        title: "Basic Color",
        price: "Starting from: 400K",
        description: "Pewarnaan rambut dasar dengan pilihan warna natural, termasuk konsultasi warna dan perawatan rambut post-coloring"
      },
      {
        title: "Coloring Akar Only + Dryer",
        price: "Starting from: 350K",
        description: "Pewarnaan khusus untuk akar rambut, menyamarkan uban dan menyegarkan warna yang memudar, dilengkapi dengan pengeringan profesional"
      },
      {
        title: "Coloring Akar + Blow/Catok + Wash + Styling",
        price: "Starting from: 450K",
        description: "Paket lengkap pewarnaan akar rambut dengan tambahan styling sesuai pilihan untuk hasil yang lebih maksimal"
      },
      {
        title: "Fashion Color",
        price: "Starting from: 800K",
        description: "Pewarnaan rambut dengan warna-warna fashion terkini, termasuk proses bleaching dan perawatan untuk menjaga keindahan warna"
      },
      {
        title: "Bleaching",
        price: "Starting from: 400K",
        description: "Proses pemudaan warna rambut untuk persiapan pewarnaan fashion atau mencerahkan warna rambut natural"
      },
      {
        title: "Bleaching Highlight",
        price: "Starting from: 625K",
        description: "Teknik highlight dengan bleaching untuk memberikan dimensi dan tekstur pada rambut dengan hasil yang natural"
      },
      {
        title: "Balayage/Ombre/Peak Abow",
        price: "Starting from: 850K",
        description: "Teknik pewarnaan gradasi modern untuk tampilan yang lebih dinamis dan stylish, disesuaikan dengan karakter wajah"
      },
      {
        title: "Basic Perm",
        price: "Starting from: 400K",
        description: "Teknik pengeritingan dasar untuk menambah volume dan tekstur pada rambut dengan hasil natural"
      },
      {
        title: "Korean Perm",
        price: "Starting from: 500K",
        description: "Gaya pengeritingan modern ala Korea dengan hasil ikal yang lembut dan natural, cocok untuk berbagai jenis rambut"
      },
      {
        title: "Digital Perm",
        price: "Starting from: 1.400K",
        description: "Teknologi pengeritingan digital modern dengan hasil yang lebih tahan lama dan mudah diatur"
      }
    ],
    'smoothing-keratin': [
      {
        title: "Smoothing",
        price: "Starting from: 450K",
        description: "Pelurusan rambut dengan teknologi smoothing terkini untuk hasil rambut lurus yang natural dan mudah diatur"
      },
      {
        title: "Smoothing Color",
        price: "Starting from: 1000K",
        description: "Kombinasi treatment smoothing dan pewarnaan rambut untuk tampilan baru yang lebih fresh dan stylish"
      },
      {
        title: "Infuse Keratin",
        price: "Starting from: 650K",
        description: "Treatment keratin untuk memulihkan kerusakan rambut, menguatkan struktur, dan memberikan kilau alami"
      }
    ],
    'papakilo-package': [
      {
        title: "Cut + Creambath + Dry",
        price: "275K",
        description: "Paket perawatan lengkap meliputi potong rambut, creambath untuk nutrisi, dan pengeringan profesional"
      },
      {
        title: "Cut + Creambath + Blow Natural",
        price: "290K",
        description: "Kombinasi potong rambut dan creambath dengan tambahan blow natural untuk hasil yang lebih bervolume"
      },
      {
        title: "Cut + Creambath + Blow Styling",
        price: "350K",
        description: "Paket premium termasuk potong rambut, creambath, dan blow styling untuk tampilan yang lebih maksimal"
      }
    ]
  },

  'loreal': {
    'hair-treatments-loreal': [
      {
        title: "Creambath Celebrity",
        price: "235K",
        description: "Perawatan creambath premium dengan produk L'Oreal, termasuk pijatan kepala yang menenangkan dan perawatan intensif untuk rambut"
      },
      {
        title: "Hair Mask + Dryer",
        price: "225K",
        description: "Treatment hair mask L'Oreal untuk rambut rusak, dilengkapi dengan pengeringan profesional untuk hasil maksimal"
      },
      {
        title: "Hair Mask + Blow/Catok",
        price: "250K",
        description: "Perawatan hair mask L'Oreal dengan pilihan styling blow atau catok untuk tampilan yang lebih rapi"
      },
      {
        title: "Hair Mask + Blow/Variation/Curly",
        price: "275K",
        description: "Kombinasi hair mask L'Oreal dengan styling kreatif untuk tampilan bervolume atau bergelombang"
      },
      {
        title: "Hair Spa + Dryer",
        price: "460K",
        description: "Treatment spa rambut premium L'Oreal dengan pengeringan profesional untuk rambut lebih sehat"
      },
      {
        title: "Hair Spa + Blow/Catok",
        price: "435K",
        description: "Spa rambut L'Oreal dengan pilihan styling blow atau catok untuk hasil yang tahan lama"
      },
      {
        title: "Hair Spa + Blow/Variation/Curly",
        price: "480K",
        description: "Perawatan spa rambut L'Oreal lengkap dengan styling khusus untuk tampilan yang lebih dinamis"
      },
      {
        title: "Hair Scrub",
        price: "195K",
        description: "Deep cleansing kulit kepala dengan hair scrub L'Oreal untuk menghilangkan kotoran dan sel kulit mati"
      },
      {
        title: "Hair Scrub + Blow",
        price: "250K",
        description: "Treatment hair scrub L'Oreal dengan tambahan blow styling untuk hasil yang lebih maksimal"
      },
      {
        title: "Shampoo Special",
        price: "40K",
        description: "Pencucian rambut dengan shampo khusus L'Oreal sesuai dengan jenis rambut Anda"
      }
    ],
    'coloring-perm-loreal': [
      {
        title: "Basic Color",
        price: "Starting from: 600K",
        description: "Pewarnaan rambut dengan produk L'Oreal berkualitas tinggi untuk hasil warna yang tahan lama"
      },
      {
        title: "Coloring Akar Only + Dry",
        price: "Starting from: 500K",
        description: "Pewarnaan akar rambut dengan L'Oreal untuk menutupi uban dan menyegarkan warna"
      },
      {
        title: "Coloring Akar + Blow Catok",
        price: "Starting from: 600K",
        description: "Pewarnaan akar rambut L'Oreal dengan tambahan styling untuk hasil yang lebih rapi"
      },
      {
        title: "Catok + Wash + Styling",
        price: "Starting from: 600K",
        description: "Penataan rambut lengkap dengan pencucian dan styling menggunakan produk L'Oreal"
      },
      {
        title: "Fashion Color",
        price: "Starting from: 1.300K",
        description: "Pewarnaan fashion dengan produk L'Oreal premium untuk hasil warna yang vibrant"
      },
      {
        title: "Bleaching",
        price: "Starting from: 700K",
        description: "Proses pemudaan warna rambut dengan teknologi L'Oreal yang aman untuk rambut"
      },
      {
        title: "Bleaching / Highlight",
        price: "Starting from: 900K",
        description: "Teknik highlight menggunakan produk L'Oreal untuk dimensi warna yang natural"
      },
      {
        title: "Balayage / Ombre / Peak Abow",
        price: "Starting from: 1.000K",
        description: "Teknik pewarnaan gradasi modern dengan L'Oreal untuk tampilan yang trendy"
      },
      {
        title: "Basic Perm",
        price: "Starting from: 400K",
        description: "Pengeritingan dasar dengan produk L'Oreal untuk tekstur natural"
      },
      {
        title: "Celebrity Perm",
        price: "Starting from: 500K",
        description: "Gaya keriting premium ala selebriti dengan produk L'Oreal terbaik"
      },
      {
        title: "Korean Perm",
        price: "Starting from: 950K",
        description: "Teknik keriting gaya Korea menggunakan produk L'Oreal untuk hasil yang elegant"
      },
      {
        title: "Digital Perm",
        price: "Starting from: 2.400K",
        description: "Teknologi pengeritingan digital dengan L'Oreal untuk hasil presisi maksimal"
      }
    ],
    'smoothing-keratin-loreal': [
      {
        title: "Smoothing XTenso",
        price: "800K",
        description: "Pelurusan rambut dengan teknologi XTenso L'Oreal untuk hasil yang tahan lama"
      },
      {
        title: "Smoothing Color",
        price: "1.400K",
        description: "Kombinasi smoothing dan pewarnaan dengan produk L'Oreal untuk tampilan baru yang maksimal"
      }
    ]
  },
};
  
export default ServiceListData;